import { globalAPI } from '@wiggot/apis'
import { useQuery } from '@wiggot/libs/react-query'
import type { UseConfigQueryOptions } from '@wiggot/libs/react-query'

import { METRICS_KEYS } from '../const'
import { zAppraisal, zCapitalGains } from './schema'
import type { Appraisal, CapitalGains, CapitalGainsResponse } from './schema'
import { RQKEYS as appraisalsKeys } from './const'

interface QueryParams {
  latitude: number
  longitude: number
  isNewVersion?: boolean
}
interface AppraisalQueryParams {
  id: string
}

export function useCapitalGainsQuery(
  { latitude, longitude }: QueryParams,
  queryOptions: UseConfigQueryOptions<CapitalGains> = {}
) {
  return useQuery({
    queryKey: METRICS_KEYS.getCapitalGains(latitude, longitude).queryKey,
    queryFn: async () => {
      const response = await globalAPI.post<CapitalGainsResponse, QueryParams>(
        '/metrics/capital-gain/v5',
        { latitude, longitude }
      )
      if (!response.success) {
        throw new Error(response.message)
      }

      return zCapitalGains().parse(response?.data)
    },
    staleTime: Infinity,
    enabled: Boolean(latitude && longitude),
    ...queryOptions
  })
}

export function useAppraisalQuery(
  { id }: AppraisalQueryParams,
  queryOptions: UseConfigQueryOptions<Appraisal> = {}
) {
  const { data, isError, ...rest } = useQuery({
    queryKey: appraisalsKeys.getAppraisal(id).queryKey,
    queryFn: async () => {
      const response = await globalAPI.get(`/appraisals/${id}`)

      return zAppraisal().parse(response)
    },
    ...queryOptions
  })

  return { data, isError, ...rest }
}
